import { Search } from "lucide-react";

export default function SearchBar({ value, onChange, placeholder, testid }) {
    return (
        <div className="glass-card flex items-center gap-3 rounded-xl px-4 py-3">
            <Search className="h-4 w-4 shrink-0 text-violet-400" />
            <input
                data-testid={testid}
                type="text"
                value={value}
                onChange={(e) => onChange(e.target.value)}
                placeholder={placeholder}
                className="w-full bg-transparent text-sm text-gray-100 outline-none placeholder:text-gray-500"
            />
        </div>
    );
}
